import { getCustomerDetail } from "store/actions/customer-action";
import { AppDispatch, RootState } from "store/store";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default (id: number) => {
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch()

    const customer_detail = useSelector((state: RootState) => state.customer?.customer_detail);

    useEffect(() => {
        dispatch(getCustomerDetail(id));
    }, []);

    return {
        navigate,
        customer_detail,

    }
}